<template>
  <div class="popstyle2" style="padding: 0 12px;">
    <b-modal id="users-management-modal" ref="usersManagementModal" size="lg" :title="modalTitle"
             centered :hide-footer="true" style="margin-top: 0" @hidden="onHidden" disabled="true">
      <UsersList :permisos="permisos"></UsersList>
    </b-modal>
  </div>
</template>

<style scoped>
</style>

<script>
import Loader from '@/components/Layout/Loader.vue';
import Table from '@/components/Modules/Table/Table.vue';
import UsersList from './users-list/UsersList';
import NewUser from './new-user/NewUser';

export default {
  name: 'UsersManagement',
  props: ['permisos'],
  components: {NewUser, UsersList, Loader, Table},
  data () {
    return {
      loading: 0,
      modalTitle: 'Gestión Usuarios'
    };
  },
  computed: {},
  mounted: function () {
    this.$refs.usersManagementModal.show();
  },
  methods: {
    onHidden: function () {
      this.details = false;
      this.$parent.showUsersManagement = false;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Layout/SystemManagement/users-management/UsersManagement.vue